import { clients } from '@oncolens/oncolens-ui/lib/api/client';
import { AxiosError } from 'axios';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { OrganizationKeys } from './organization.keys';

export const deleteOrganizationLogo = (organizationId: string): Promise<void> =>
  clients.admin.delete(`/organizations/${organizationId}/logo`);

export function useDeleteOrganizationLogo(
  organizationId: string,
  options?: UseMutationOptions<void, AxiosError, void>,
) {
  const queryClient = useQueryClient();

  return useMutation(() => deleteOrganizationLogo(organizationId), {
    onSuccess: () => {
      queryClient.invalidateQueries(OrganizationKeys.detail(organizationId));
    },
    ...options,
  });
}
